module.exports = "/static/assets/2ffafb13c4cfe8ce811bbe1b4a0c2f94.png";